<template>
  <div>
    <h5 v-if="order">№ {{ order.id }} от {{ formatDate(order.create_at) }}</h5>
    <div class="product-card d-flex flex-md-row flex-column align-items-start">
      <img
        @click="goToItem()"
        class="product-image"
        :src="
          product?.images?.length
            ? product.images[0]?.image
            : require('@/assets/images/logo_x.svg')
        "
        alt=""
      />
      <div v-if="!product.is_published" class="status inactive">
        На модерации
      </div>
      <div class="product-info ms-md-4 col-md-4 col-12 mt-md-0 mt-2">
        <h4 @click="goToItem()">{{ product.name }}</h4>
        <p>{{ formatPrice(product.price) }}</p>
      </div>
      <template v-if="!order">
        <div class="d-flex flex-column col-md-1 col-2">
          <div
            class="d-flex justify-content-between align-items-center ms-md-4"
          >
            <svg
              width="27"
              height="21"
              viewBox="0 0 27 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5 21C13.2388 21 13.0179 20.918 12.8371 20.7539L3.43527 12.5234C3.33482 12.4505 3.19671 12.332 3.02093 12.168C2.84515 12.0039 2.56641 11.7054 2.18471 11.2725C1.80301 10.8395 1.4615 10.3952 1.16016 9.93945C0.858817 9.48372 0.590123 8.93229 0.354074 8.28516C0.118025 7.63802 0 7.00911 0 6.39844C0 4.39323 0.637835 2.82552 1.9135 1.69531C3.18917 0.565104 4.95201 0 7.20201 0C7.82478 0 8.4601 0.0979818 9.10798 0.293945C9.75586 0.489909 10.3585 0.754232 10.916 1.08691C11.4735 1.4196 11.9531 1.73177 12.3549 2.02344C12.7567 2.3151 13.1384 2.625 13.5 2.95312C13.8616 2.625 14.2433 2.3151 14.6451 2.02344C15.0469 1.73177 15.5265 1.4196 16.084 1.08691C16.6415 0.754232 17.2441 0.489909 17.892 0.293945C18.5399 0.0979818 19.1752 0 19.798 0C22.048 0 23.8108 0.565104 25.0865 1.69531C26.3622 2.82552 27 4.39323 27 6.39844C27 8.41276 25.8499 10.4635 23.5497 12.5508L14.1629 20.7539C13.9821 20.918 13.7612 21 13.5 21Z"
                fill="#D44233"
              />
            </svg>
            {{ product.number_of_like }}
          </div>
          <div
            class="d-flex justify-content-between align-items-center ms-md-4 mt-2"
          >
            <svg
              width="27"
              height="13"
              viewBox="0 0 27 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5 0.000309634C14.8184 0.000309634 16.1016 0.165345 17.3496 0.495415C18.5977 0.825485 19.793 1.27827 20.9355 1.85378C22.0781 2.42929 23.1592 3.11905 24.1787 3.92307C25.1982 4.72708 26.1387 5.58611 27 6.50015C26.1387 7.43112 25.2026 8.29015 24.1919 9.07724C23.1812 9.86433 22.1001 10.5499 20.9487 11.1338C19.7974 11.7178 18.5977 12.1748 17.3496 12.5049C16.1016 12.835 14.8184 13 13.5 13C12.1816 13 10.8984 12.835 9.65039 12.5049C8.40234 12.1748 7.20703 11.722 6.06445 11.1465C4.92188 10.571 3.83643 9.88549 2.80811 9.08994C1.77979 8.29438 0.84375 7.43112 0 6.50015C0.852539 5.57765 1.78857 4.71862 2.80811 3.92307C3.82764 3.12751 4.90869 2.44198 6.05127 1.86648C7.19385 1.29097 8.39355 0.833949 9.65039 0.495415C10.9072 0.156881 12.1904 -0.00815371 13.5 0.000309634ZM18.5625 6.50015C18.5625 5.83155 18.4307 5.20103 18.167 4.6086C17.9033 4.01616 17.5386 3.4999 17.0728 3.05981C16.6069 2.61971 16.0708 2.27272 15.4644 2.01882C14.8579 1.76492 14.2031 1.63373 13.5 1.62527C12.8057 1.62527 12.1509 1.75222 11.5356 2.00612C10.9204 2.26002 10.3843 2.61125 9.92725 3.05981C9.47021 3.50836 9.10986 4.02463 8.84619 4.6086C8.58252 5.19257 8.44629 5.82309 8.4375 6.50015C8.4375 7.16876 8.56934 7.79928 8.83301 8.39171C9.09668 8.98415 9.46143 9.50041 9.92725 9.9405C10.3931 10.3806 10.9292 10.7276 11.5356 10.9815C12.1421 11.2354 12.7969 11.3666 13.5 11.375C14.1943 11.375 14.8491 11.2481 15.4644 10.9942C16.0796 10.7403 16.6157 10.3891 17.0728 9.9405C17.5298 9.49195 17.8901 8.97568 18.1538 8.39171C18.4175 7.80774 18.5537 7.17722 18.5625 6.50015ZM2.3335 6.50015C3.15967 7.27032 4.03857 7.97278 4.97021 8.60753C5.90186 9.24228 6.89941 9.7797 7.96289 10.2198C7.56738 9.67814 7.26855 9.08994 7.06641 8.45519C6.86426 7.82044 6.75879 7.16876 6.75 6.50015C6.75 5.84001 6.85107 5.19257 7.05322 4.55782C7.25537 3.92307 7.55859 3.33063 7.96289 2.78052C6.89941 3.21215 5.90186 3.74534 4.97021 4.38009C4.03857 5.01484 3.15967 5.72153 2.3335 6.50015ZM19.0371 10.2198C20.1006 9.78816 21.0981 9.25497 22.0298 8.62022C22.9614 7.98547 23.8403 7.27878 24.6665 6.50015C23.8403 5.72999 22.9614 5.02753 22.0298 4.39278C21.0981 3.75803 20.1006 3.22061 19.0371 2.78052C19.4326 3.32217 19.7314 3.91037 19.9336 4.54512C20.1357 5.17987 20.2412 5.83155 20.25 6.50015C20.25 7.1603 20.1489 7.80774 19.9468 8.44249C19.7446 9.07724 19.4414 9.66968 19.0371 10.2198ZM13.5 8.12512C13.2627 8.12512 13.043 8.0828 12.8408 7.99817C12.6387 7.91353 12.4629 7.79928 12.3135 7.6554C12.1641 7.51152 12.041 7.33803 11.9443 7.13491C11.8477 6.93179 11.8037 6.7202 11.8125 6.50015C11.8125 6.27164 11.8564 6.06006 11.9443 5.8654C12.0322 5.67075 12.1509 5.50148 12.3003 5.3576C12.4497 5.21373 12.6299 5.09524 12.8408 5.00214C13.0518 4.90905 13.2715 4.86673 13.5 4.87519C13.7373 4.87519 13.957 4.91751 14.1592 5.00214C14.3613 5.08678 14.5371 5.20103 14.6865 5.34491C14.8359 5.48879 14.959 5.66228 15.0557 5.8654C15.1523 6.06852 15.1963 6.28011 15.1875 6.50015C15.1875 6.72867 15.1436 6.94025 15.0557 7.13491C14.9678 7.32956 14.8491 7.49883 14.6997 7.64271C14.5503 7.78658 14.3701 7.90507 14.1592 7.99817C13.9482 8.09126 13.7285 8.13358 13.5 8.12512Z"
                fill="#3E3E3E"
              />
            </svg>
            {{ product.views }}
          </div>
        </div>
        <button
          class="ms-auto btn btn-link"
          @click="editProduct()"
          v-if="product.is_published"
        >
          Редактировать
        </button>
        <button
          class="ms-auto btn btn-link"
          @click="deleteProduct()"
          v-if="product.is_published"
        >
          Удалить
        </button>
      </template>
      <template v-else>
        <ul class="ms-auto">
          <li>
            <span>Статус</span>
            {{ statusLabel(order.status) }}
          </li>
          <li><span>Оплата</span> {{ paymentStatusLabel(order.paid) }}</li>
        </ul>

        <button
          class="btn btn-primary"
          @click.prevent="openReviewModal"
          v-if="order.status === 'completed'"
        >
          Оценить товар
        </button>
      </template>
    </div>
  </div>
  <ReviewModal
    v-if="isReviewModalOpen"
    @close="closeReviewModal"
    :id="product.id"
  />
</template>

<script>
import { defineComponent, ref } from "vue";
import MarketplaceService from "../../services/marketplace";
import { useRouter } from "vue-router";
import moment from "moment";
import ReviewModal from "@/components/Modals/ReviewModal.vue";

export default defineComponent({
  name: "NewProductCard",
  emits: ["deleted"],
  components: {
    ReviewModal,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    order: Object,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const productAdded = ref(false);
    const likedProduct = ref(props.product?.is_liked);
    const isReviewModalOpen = ref(false);

    const openReviewModal = () => {
      isReviewModalOpen.value = true;
    };

    const closeReviewModal = () => {
      isReviewModalOpen.value = false;
    };

    const clickLike = async () => {
      if (!likedProduct.value) {
        await MarketplaceService.addToFavorite(props.product.id);
        likedProduct.value = true;
      } else {
        await MarketplaceService.removeFromFavorite(props.product.id);
        likedProduct.value = false;
      }
    };

    const goToItem = () => {
      if (props.product.is_published) {
        router.push({
          name: "MarketplaceItem",
          params: { id: props.product.id },
        });
      }
    };

    const formatDate = (date) => {
      return moment(date).format("DD.MM.YYYY");
    };

    const formatPrice = (price) => {
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    };

    const statusLabel = (status) => {
      switch (status) {
        case "pending":
          return "Ожидается";
        case "in_progress":
          return "В пути";
        case "not_paid":
          return "Не оплачен";
        case "completed":
          return "Выполнен";
        default:
          return "";
      }
    };

    const paymentStatusLabel = (status) => {
      switch (status) {
        case true:
          return "Оплачено";
        case false:
          return "Не оплачено";
      }
    };

    const editProduct = () => {
      router.push(`/profile/products/edit/${props.product.id}`);
    };

    const deleteProduct = async () => {
      try {
        await MarketplaceService.deleteProduct(props.product.id);
        emit("deleted", props.product.id);
      } catch (error) {
        console.error("Ошибка при удалении продукта:", error);
      }
    };

    return {
      isReviewModalOpen,
      likedProduct,
      productAdded,
      router,
      goToItem,
      clickLike,
      formatDate,
      statusLabel,
      paymentStatusLabel,
      closeReviewModal,
      openReviewModal,
      editProduct,
      deleteProduct,
      formatPrice,
    };
  },
});
</script>

<style scoped lang="scss">
p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.like-button {
  padding: 0;
  border: none;
  cursor: pointer;
  svg {
    transition: all 0.2s;
    fill: #fff;
    path {
      stroke: #d44233;
    }
  }
  background-color: inherit;

  &.liked {
    svg {
      fill: #d44233;
      path {
        stroke: #d44233;
      }
    }
  }
}
.product-card {
  position: relative;
  &:hover {
    cursor: pointer;
  }
}

.product-image {
  min-width: 220px;
  height: 120px;
  object-fit: cover;
  border-radius: 30px;
}
.status {
  position: absolute;
  left: 1rem;
  top: 1rem;
}
.product-info {
  h4,
  .h4 {
    color: rgba(0, 199, 130, 1);
  }
  p {
    font-size: 16px;
    font-weight: 700;
    line-height: 23.87px;
  }
}

.rating {
  color: #ffc107;
  margin-bottom: 10px;
}
ul {
  list-style: none;
  li {
    font-size: 12px;
    color: #676767;
    span {
      max-width: 30%;
      color: #a3a3a3;
      font-size: 15px;
    }
  }
}
</style>
